// extracted by mini-css-extract-plugin
module.exports = {"login-layout":"login-layout_login-layout__yEaHP","header":"login-layout_header__Q56IW","footer":"login-layout_footer__foAAZ","separate":"login-layout_separate__W6qn_"};